<template>
  <div class="audioPlay">
    <div v-if="sound" class="upload-action">
      <Icon type="md-play" v-if="!playing" @click.stop="onPlay" />
      <Icon type="md-pause" v-else @click.stop="onPause" />
      <a class="downloadBtn" :download="download.fileName" :href="download.href">
        <Icon class="downloadIcon" type="md-download"/>
      </a>
      <slot/>
    </div>
  </div>
</template>

<script>
import { Howl, Howler } from "howler";

export default {
  data() {
    return {
      playing: false,
    }
  },
  props: {
    filepath: {
      type: String,
      default: '',
    },
  },
  computed: {
    sound() {
      if (!this.filepath) return undefined;
      const urlStr = this.filepath.split("record")[1];
      return new Howl({
        src: [`${webConfig.api.audio}${urlStr}`],
        onend: () => {
          this.playing = false;
        },
      });
    },
    download() {
      if (!this.filepath) return undefined;
      const urlStr = this.filepath.split("record")[1];
      const f = this.filepath.split('/') || []
      return {
        href: `${webConfig.api.audio}${urlStr}`,
        fileName: f[f.length - 1],
      }
    }
  },
  methods: {
    // 播放录音
    onPlay() {
      this.playing = true;
      this.sound.play();
    },
    // 停止播放
    onPause() {
      this.playing = false;
      this.sound.pause();
    },
  }
}
</script>

<style lang="scss" scoped>
.audioPlay{
  display: inline-block;
  cursor: pointer;
}
.upload-action {
  display: flex;
}
.downloadBtn {
  color: #000;
}
.downloadIcon {
  vertical-align: text-top;
}
</style>